import {selectionActionTypes as actionTypes, planApiActionTypes} from "../constants";
import {reset as resetPlan} from "../features/plan/planReducer";

import {
    addSleeve,
    removeSleeve,
    addGrounding,
    removeGrounding,
    addWallDrainage,
    removeWallDrainage,
    addBlockOut,
    resizeBlockOut,
    removeBlockOut,
    addCRail,
    resizeCRail,
    removeCRail,
} from "../features/vault/vaultSlice"

import {addDrainage, removeDrainage} from "../features/floor/floorSlice"
import {
    addManhole,
    resizeManhole,
    removeManhole,
    addBlockOut as addLidBlockOut,
    resizeBlockOut as resizeLidBlockOut,
    removeBlockOut as removeLidBlockOut,
    addCircularBlockOut as addCircularLidBlockOut,
    resizeCircularBlockOut as resizeCircularLidBlockOut,
    removeCircularBlockOut as removeCircularLidBlockOut,
} from "../features/lid/lidSlice"
import {
    addBlockOut as addIntermediateCeilingBlockOut,
    resizeBlockOut as resizeIntermediateCeilingBlockOut,
    removeBlockOut as removeIntermediateCeilingBlockOut,
    addCircularBlockOut as addCircularIntermediateCeilingBlockOut,
    resizeCircularBlockOut as resizeCircularIntermediateCeilingBlockOut,
    removeCircularBlockOut as removeCircularIntermediateCeilingBlockOut,
} from "../features/intermediateCeiling/intermediateCeilingSlice"


const initialState = [];

export const selectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.setSelected:

            return action.data;

        case actionTypes.addSelected:
            return [...state, action.data];

        case actionTypes.removeSelected:
            return state.filter(id => id !== action.data);

        case actionTypes.clearSelected:
        case resetPlan:
        case planApiActionTypes.readPlanSuccess:
            return initialState;

        case addSleeve.type:
            return [action.payload.sleeve.id];

        case addGrounding.type:
            return [action.payload.grounding.id];

        case addWallDrainage.type:
            return [action.payload.drainage.id];

        case addBlockOut.type:
            return [action.payload.blockOut.id];

        case addCRail.type:
            return [action.payload.cRail.id];

        case addDrainage.type:
            return [action.payload.drainage.id];

        case addManhole.type:
            return [action.payload.manhole.id];

        case addLidBlockOut.type:
        case addCircularLidBlockOut.type:
        case addIntermediateCeilingBlockOut.type:
        case addCircularIntermediateCeilingBlockOut.type:
            return [action.payload.blockOut.id];

        case resizeBlockOut.type:
        case resizeCRail.type:
        case resizeManhole.type:
        case resizeLidBlockOut.type:
        case resizeCircularLidBlockOut.type:
        case resizeIntermediateCeilingBlockOut.type:
        case resizeCircularIntermediateCeilingBlockOut.type:
            return [action.payload.id];

        case removeSleeve.type:
        case removeGrounding.type:
        case removeWallDrainage.type:
        case removeBlockOut.type:
        case removeCRail.type:
        case removeDrainage.type:
        case removeManhole.type:
        case removeLidBlockOut.type:
        case removeCircularLidBlockOut.type:
        case removeIntermediateCeilingBlockOut.type:
        case removeCircularIntermediateCeilingBlockOut.type:
            return !!action.payload.id ? state.filter(id => id !== action.payload.id) : initialState;

        default:
            return state;
    }
}

